import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Weddingcarrentalmumbai() {



const cardData = {
  keyword: " Wedding Car Rental Mumbai",

headingDescription:
  "Omshree Cab provides premium and reliable wedding car rental services in Mumbai, designed to make your special day elegant, comfortable, and memorable. Whether you need a stylish car for the groom’s grand entry, a luxury vehicle for the bride, or multiple cars for family members and guests, our wedding cab service ensures smooth transportation with professional chauffeurs and well-maintained vehicles. We offer flexible rental packages for baraat, reception, engagement ceremonies, pre-wedding shoots, and full-day wedding events. Our fleet includes luxury sedans, premium SUVs, vintage-style cars, and spacious vehicles suitable for wedding processions and guest transport. With punctual service, beautifully decorated cars, and transparent pricing, Omshree Cab ensures that your wedding transportation is stress-free and perfectly coordinated across Mumbai.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India is one of Mumbai’s most iconic landmarks and a popular location for wedding photography and pre-wedding shoots. The majestic arch monument overlooking the Arabian Sea provides a beautiful historical backdrop that couples often choose for capturing memorable moments. The surrounding Colaba area also offers elegant hotels and banquet venues suitable for wedding events. Arriving at such a landmark in a decorated wedding car adds a touch of luxury and elegance to the celebration."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is one of the most scenic coastal roads in Mumbai and is popularly known as the Queen’s Necklace because the streetlights create a glowing necklace shape at night. Couples often choose this location for romantic drives and pre-wedding photoshoots because of its stunning sea views and beautiful sunsets. The long promenade and open skyline create a perfect cinematic atmosphere. Traveling in a decorated wedding car along Marine Drive adds a luxurious and unforgettable experience to wedding celebrations."
  },
  {
    title: "Bandra Fort",
    description:
      "Bandra Fort, also known as Castella de Aguada, is a historic fort located near Bandra Bandstand overlooking the Arabian Sea. The location offers panoramic views of the Bandra-Worli Sea Link and has become a popular spot for pre-wedding photography. Couples enjoy the historic architecture, sea breeze, and peaceful surroundings. Arriving here in a stylish wedding car makes the experience even more special and adds elegance to wedding photo sessions."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most popular beaches and is often chosen for romantic wedding photos and couple moments before or after ceremonies. The beach provides wide sandy shores, sunset views, and a relaxed atmosphere perfect for photography and celebrations. Many wedding couples visit the beach for informal photoshoots or peaceful drives. A luxury wedding car ride to Juhu Beach adds comfort and style to the experience."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park offers a beautiful natural setting within Mumbai and is often used for outdoor photography and peaceful pre-wedding shoots. The park features lush greenery, scenic landscapes, and historical attractions like the Kanheri Caves. Couples looking for nature-themed wedding photography often choose this location for its serene atmosphere. A comfortable wedding cab ensures convenient access and allows couples to enjoy their special moments without transportation concerns."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves, located on Elephanta Island in Mumbai Harbour, are famous for ancient rock-cut sculptures and historic architecture. The caves create a dramatic and artistic setting for couples who want unique and culturally rich wedding photographs. Visitors usually travel by ferry from the Gateway of India to reach the island. Booking a wedding cab ensures smooth transportation to the ferry point and makes the overall experience more comfortable."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is one of Mumbai’s most modern landmarks and provides spectacular views of the Arabian Sea and city skyline. The bridge has become a popular route for stylish wedding drives and cinematic pre-wedding videos. Many couples enjoy driving across the sea link in decorated luxury cars as part of their wedding celebration. The impressive architecture and night lighting make it an unforgettable experience."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a lively street market and cultural hub in South Mumbai. The area features historic buildings, charming cafes, and boutique shops that create a vibrant urban setting. Couples sometimes explore the streets for candid wedding photography and shopping before the ceremony. A comfortable wedding cab makes it easy to travel through the busy area while enjoying the city atmosphere."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, located on Malabar Hill, offer beautiful landscaped terraces with panoramic views of Marine Drive and the Arabian Sea. The peaceful greenery and scenic viewpoints create a romantic environment perfect for wedding photography and quiet moments. Couples often visit the garden for relaxed photoshoots before or after wedding events. A wedding cab ensures comfortable travel to this elevated location."
  },
  {
    title: "Nariman Point",
    description:
      "Nariman Point is a prominent business and waterfront district in South Mumbai known for its skyline views and elegant surroundings. The area is popular for luxury hotels, wedding receptions, and stylish photoshoots along the sea-facing promenade. Couples enjoy the modern city backdrop combined with ocean views for capturing memorable wedding moments. Arriving here in a luxury wedding car creates a grand and sophisticated entrance."
  }
],




services: [
{
name: "Wedding Car Rental Mumbai",
description: "Wedding car rental in Mumbai offers elegant and luxurious vehicles for couples celebrating their special day. Our premium fleet includes luxury sedans, vintage cars, and stylish SUVs designed to add grandeur to wedding ceremonies. Professional chauffeurs ensure punctual arrival and smooth driving throughout the event. Vehicles are beautifully maintained to match the elegance of wedding occasions. Pickup services are available from homes, hotels, banquet halls, and wedding venues across Mumbai. Ideal for bridal entry, groom arrival, and wedding photoshoots. Spacious interiors provide comfort for the bride and groom during travel. Luxury wedding car rental ensures a stylish and memorable wedding experience."
},
{
name: "Wedding Car Hire Mumbai",
description: "Wedding car hire in Mumbai provides premium transportation for couples looking to make a grand entrance on their wedding day. Our fleet includes luxury sedans, vintage cars, and premium SUVs designed for wedding events. Professional drivers ensure safe driving and timely arrival at wedding venues. Pickup services are available across Mumbai including homes, hotels, and banquet halls. Ideal for bridal entry, groom arrival, and wedding processions. Elegant interiors ensure comfort during travel. Flexible booking options allow convenient event planning. Luxury wedding car hire ensures a memorable wedding celebration."
},
{
name: "Luxury Wedding Car Mumbai",
description: "Luxury wedding car in Mumbai offers premium vehicles designed to enhance the elegance of wedding celebrations. Our fleet includes Mercedes, BMW, Audi, and other luxury models suitable for grand wedding entrances. Professional chauffeurs ensure punctual service and smooth driving throughout the event. Vehicles are maintained in pristine condition to match wedding décor and style. Pickup services are available across Mumbai including wedding venues and hotels. Ideal for bridal entry, groom arrival, and VIP wedding guests. Spacious interiors ensure comfortable travel. Luxury wedding car services add sophistication to special occasions."
},
{
name: "Bridal Car Rental Mumbai",
description: "Bridal car rental in Mumbai provides stylish vehicles specially selected for the bride’s entry on her wedding day. Our premium fleet includes luxury sedans and beautifully decorated cars ideal for bridal transportation. Professional chauffeurs ensure safe driving and timely arrival at wedding venues. Pickup services are available from homes, hotels, and bridal makeup studios across Mumbai. Ideal for bridal entry, wedding photoshoots, and special ceremonies. Elegant interiors ensure comfortable travel for the bride. Flexible booking options allow customized wedding arrangements. Bridal car rental ensures a glamorous wedding arrival."
},
{
name: "Wedding Cab Service Mumbai",
description: "Wedding cab service in Mumbai provides reliable transportation for wedding guests, family members, and special event travel. Our fleet includes comfortable sedans and SUVs suitable for group transportation during wedding events. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available across Mumbai including homes, hotels, and wedding venues. Ideal for guest transfers, airport pickups, and event transportation. Spacious seating ensures comfortable travel for passengers. Flexible booking options allow easy event planning. Wedding cab services ensure smooth transportation during celebrations."
},
{
name: "Wedding Car Booking Mumbai",
description: "Wedding car booking in Mumbai allows couples to reserve luxury vehicles easily for their wedding ceremony. Our fleet includes premium cars, luxury sedans, and vintage vehicles suitable for grand wedding entrances. Professional chauffeurs ensure punctual service and smooth driving during the event. Pickup services are available across Mumbai including homes, hotels, and wedding halls. Ideal for bridal entry, groom arrival, and wedding photography. Spacious interiors ensure comfortable travel. Flexible booking options allow convenient planning. Wedding car booking ensures stylish transportation for special occasions."
},
{
name: "Wedding Luxury Car Hire Mumbai",
description: "Wedding luxury car hire in Mumbai offers high-end vehicles for couples seeking premium transportation during wedding celebrations. Our fleet includes luxury sedans and premium SUVs designed for elegant wedding arrivals. Professional chauffeurs ensure safe driving and punctual pickup services. Vehicles are maintained with high standards for wedding events. Pickup services are available across Mumbai including hotels, homes, and banquet halls. Ideal for bridal entry and groom arrival. Spacious interiors ensure comfortable travel. Luxury car hire enhances the grandeur of wedding celebrations."
},
{
name: "Mercedes Wedding Car Mumbai",
description: "Mercedes wedding car in Mumbai offers premium luxury vehicles perfect for grand wedding entrances. Our Mercedes models provide stylish design, spacious interiors, and comfortable travel. Professional chauffeurs ensure smooth driving and punctual arrival at wedding venues. Pickup services are available across Mumbai including hotels, homes, and banquet halls. Ideal for bridal entry, groom arrival, and VIP wedding guests. Elegant interiors ensure luxury travel experience. Flexible booking options allow convenient wedding planning. Mercedes wedding cars add prestige and elegance to the ceremony."
},
{
name: "BMW Wedding Car Mumbai",
description: "BMW wedding car in Mumbai provides stylish luxury transportation for couples celebrating their wedding day. Our BMW vehicles offer premium interiors and smooth driving experience. Professional chauffeurs ensure punctual pickup and safe driving throughout the event. Pickup services are available across Mumbai including homes, hotels, and wedding venues. Ideal for bridal entry, groom arrival, and wedding photography sessions. Spacious seating ensures comfortable travel. Flexible booking options allow convenient reservations. BMW wedding cars ensure a glamorous wedding arrival."
},
{
name: "Audi Wedding Car Mumbai",
description: "Audi wedding car in Mumbai offers elegant and premium transportation for couples seeking stylish wedding travel. Our Audi vehicles provide luxury interiors and smooth driving experience. Professional chauffeurs ensure punctual service and safe driving throughout the ceremony. Pickup services are available across Mumbai including homes, hotels, and wedding halls. Ideal for bridal entry, groom arrival, and VIP wedding guests. Spacious interiors ensure comfortable travel during the event. Flexible booking options allow easy reservations. Audi wedding cars enhance the elegance of wedding celebrations."
},
{
name: "Vintage Wedding Car Mumbai",
description: "Vintage wedding car in Mumbai provides classic luxury vehicles perfect for traditional and royal-style weddings. Our vintage cars add timeless charm and elegance to wedding ceremonies. Professional chauffeurs ensure smooth driving and punctual arrival at wedding venues. Pickup services are available across Mumbai including hotels, homes, and wedding halls. Ideal for bridal entry, groom arrival, and wedding photography sessions. Spacious interiors ensure comfortable travel. Flexible booking options allow customized wedding planning. Vintage wedding cars create a memorable royal wedding experience."
},
{
name: "Luxury Wedding Cab Mumbai",
description: "Luxury wedding cab in Mumbai offers premium transportation for wedding couples and VIP guests. Our fleet includes luxury sedans and SUVs designed for stylish wedding travel. Professional chauffeurs ensure safe driving and punctual pickup services. Pickup services are available across Mumbai including homes, hotels, and wedding venues. Ideal for bridal entry, groom arrival, and guest transportation. Spacious interiors ensure comfortable journeys. Flexible booking options allow convenient reservations. Luxury wedding cab services ensure elegant travel during wedding celebrations."
}
],

tableData: [
["Wedding Car Rental Mumbai","Wedding Car Hire Mumbai"],
["Luxury Wedding Car Mumbai","Bridal Car Rental Mumbai"],
["Wedding Cab Service Mumbai","Wedding Car Booking Mumbai"],
["Wedding Luxury Car Hire Mumbai","Mercedes Wedding Car Mumbai"],
["BMW Wedding Car Mumbai","Audi Wedding Car Mumbai"],
["Vintage Wedding Car Mumbai","Luxury Wedding Cab Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Premium Wedding Cars",
    WhyChoosedescription: "Omshree Cabs offers elegant and well-maintained vehicles specially suitable for weddings and special occasions. Our premium cars add style and luxury to your wedding arrival and ensure a grand experience."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "We provide clear and transparent pricing for wedding car rentals in Mumbai. All rental charges, waiting time, and travel packages are explained before booking so there are no hidden costs."
  },
  {
    WhyChooseheading: "Professional Chauffeurs",
    WhyChoosedescription: "Our trained and professional drivers understand the importance of wedding events. They ensure punctual arrival, courteous service, and a smooth ride during the ceremony."
  },
  {
    WhyChooseheading: "Decorated Wedding Cars",
    WhyChoosedescription: "Wedding cars can be beautifully decorated with flowers and ribbons according to your preference, making the bride and groom’s arrival even more special."
  },
  {
    WhyChooseheading: "Flexible Rental Packages",
    WhyChoosedescription: "We provide flexible rental options including hourly packages, full-day wedding bookings, and customized schedules depending on your wedding event requirements."
  },
  {
    WhyChooseheading: "Multiple Luxury Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including luxury sedans, SUVs, and premium cars suitable for bride and groom entry, family transport, and VIP guests."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "Our wedding car rental service provides pickup from homes, wedding venues, hotels, and airports anywhere in Mumbai, ensuring smooth transportation for your special day."
  },
  {
    WhyChooseheading: "Reliable Wedding Transportation",
    WhyChoosedescription: "Omshree Cabs is trusted by many families for wedding transportation in Mumbai. Our punctual service, clean vehicles, and professional drivers ensure a memorable wedding experience."
  }
]
};

const faqData = [
  { question: "Do you provide luxury wedding cars in Mumbai?", answer: "Yes, Omshree Cabs offers luxury sedans and premium SUVs suitable for weddings and special occasions." },
  { question: "Can the wedding car be decorated?", answer: "Yes, wedding cars can be decorated with flowers and ribbons based on the customer’s preference." },
  { question: "How long can we rent a wedding car?", answer: "Wedding cars can be rented on an hourly basis or for a full-day package depending on your event schedule." },
  { question: "Do you provide driver service with the car?", answer: "Yes, all wedding car rentals include professional chauffeur service." },
  { question: "Is pickup available from wedding venues?", answer: "Yes, we provide pickup from homes, wedding venues, hotels, and airports across Mumbai." },
  { question: "Can we book multiple cars for wedding guests?", answer: "Yes, Omshree Cabs can arrange multiple vehicles for bride, groom, family members, and guests." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided for wedding rental are fully air-conditioned and comfortable." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during wedding seasons to ensure vehicle availability." },
  { question: "Do you provide luxury cars for bride and groom entry?", answer: "Yes, premium cars are available for special bride and groom entry during wedding ceremonies." },
  { question: "Are vehicles cleaned before the event?", answer: "Yes, all vehicles are thoroughly cleaned and prepared before the wedding event." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Mehta",
    feedback:
      "We rented a wedding car from Omshree Cabs in Mumbai and the experience was fantastic. The car was beautifully decorated and arrived exactly on time.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Shah",
    feedback:
      "Omshree Cabs provided luxury cars for our wedding guests. The vehicles were clean, the drivers were professional, and the service was excellent.",
    rating: 5
  }
];




















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Wedding Car Rental Mumbai",
  "description": "Omshree Cab offers premium Wedding Car Rental in Mumbai with luxury options including Mercedes, BMW, Audi, and vintage cars. Book bridal cars, wedding cabs, and luxury wedding vehicles for your special day with reliable service and easy online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1500"
  }
};






  return (
    <div>
      

<Helmet>
  <title>Wedding Car Rental Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides luxury wedding car rental in Mumbai. Hire Mercedes, BMW, Audi, vintage cars, bridal cars, and wedding cabs with reliable service and easy online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Weddingcarrentalmumbai;